define([
    'edge/quoteandbind/common/models/Submission',
], ()=> {
    return ['$q',
        'JsonRPCService',
        'qnb.endpointConfig',
        'qnb.xCenterRouteConfig',
        ($q, JsonRPCService, endpointConfig, xCenterRouteConfig)=> {

            const xCenterRoute = xCenterRouteConfig;
            const endpoint = endpointConfig.customQuoteEndpoint;

            return {
                updateCustomQuote: (callGroups, quoteDTO, sessionID, quoteID)=> {
                    const customQuoteDTO = {
                        quote: quoteDTO,
                        sessionUUID: sessionID,
                        quoteID,
                    };
                    return JsonRPCService.send(xCenterRoute, endpoint, 'updateCustomQuote', [customQuoteDTO], callGroups);
                },

                updateCustomQuoteCoverages: (callGroups, quoteDTO, sessionID, quoteID)=> {
                    const customQuoteDTO = {
                        quote: quoteDTO,
                        sessionUUID: sessionID,
                        quoteID,
                    };
                    return JsonRPCService.send(xCenterRoute, endpoint, 'updateCustomQuoteCoverages', [customQuoteDTO], callGroups);
                },

                resetCustomQuote: (callGroups, quoteDTO, sessionID, quoteID) => {
                    const customQuoteDTO = {
                        quote: quoteDTO,
                        sessionUUID: sessionID,
                        quoteID: quoteID,
                    };
                    return JsonRPCService.send('quote', 'customquote', 'resetCustomQuote', [customQuoteDTO], callGroups);
                },
            };
        }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/services/CustomQuoteService.js